import React from "react";
import AddSupplier from "../../../Features/Forms/Suppliers/Add";

const Add = () => {
  return (
    <div>
      <AddSupplier />
    </div>
  );
};

export default Add;
